import React, { useEffect } from 'react'
import SkillCard from '../components/SkillCard'
import HtmlLogo from '../assets/img/skills/html.svg'
import CssLogo from '../assets/img/skills/css.png'
import JsLogo from '../assets/img/skills/js.png'
import PhpLogo from '../assets/img/skills/php.png'
import BsLogo from '../assets/img/skills/bs.png'
import TwLogo from '../assets/img/skills/tw.png'
import VueLogo from '../assets/img/skills/vue.png'
import NuxtLogo from '../assets/img/skills/nuxt.png'
import ReactLogo from '../assets/img/skills/react.png'
import LvLogo from '../assets/img/skills/lv.png'
import NodeLogo from '../assets/img/skills/node.png'
import ExpLogo from '../assets/img/skills/exp.png'
import MysqlLogo from '../assets/img/skills/mysql.png'
import PgsqlLogo from '../assets/img/skills/pgsql.svg'
import GcLogo from '../assets/img/skills/gc.png'
import AwsLogo from '../assets/img/skills/aws.png'
import FbLogo from '../assets/img/skills/fb.png'
import GitLogo from '../assets/img/skills/git.png'
import MaLogo from '../assets/img/skills/ma.png'

const Skills = () => {

    useEffect(() => {
        document.title = 'Arya Rizky Tri Putra - Skills'
    });

    return <section className='text-light container mx-auto pb-32 flex mt-24 px-5'>
        <div className='text-left'>
            <h3 className='font-black md:text-3xl text-2xl mb-5'>Web Technologies🌐</h3>
            <div className='grid md:grid-cols-5 grid-cols-1 gap-5 mb-10' >
                <SkillCard logo={HtmlLogo} title="HTML 5" count={5} />
                <SkillCard logo={CssLogo} title="CSS 3" count={5} />
                <SkillCard logo={JsLogo} title="Javascript" count={5} />
                <SkillCard logo={PhpLogo} title="PHP" count={5} />
                <SkillCard logo={BsLogo} title="Bootstrap" count={5} />
                <SkillCard logo={TwLogo} title="Tailwind" count={5} />
                <SkillCard logo={VueLogo} title="Vue.js" count={5} />
                <SkillCard logo={NuxtLogo} title="Nuxt.js" count={5} />
                <SkillCard logo={ReactLogo} title="React.js" count={5} />
                <SkillCard logo={LvLogo} title="Laravel" count={5} />
                <SkillCard logo={NodeLogo} title="Node.js" count={5} />
                <SkillCard logo={ExpLogo} title="Express.js" count={5} />
                <SkillCard logo={MysqlLogo} title="Mysql" count={5} />
                <SkillCard logo={PgsqlLogo} title="PostgreSql" count={5} />
                <SkillCard logo={GitLogo} title="Git VCS" count={5} />
            </div>

            <h3 className='font-black md:text-3xl text-2xl mb-5'>Mobile Technologies📱</h3>
            <div className='grid md:grid-cols-5 grid-cols-1 gap-5 mb-10' >
                <SkillCard logo={ReactLogo} title="React Native" count={3} />
                <SkillCard logo={GcLogo} title="Google Developer Console" count={3} />
            </div>

            <h3 className='font-black md:text-3xl text-2xl mb-5'>Cloud Technologies☁️</h3>
            <div className='grid md:grid-cols-5 grid-cols-1 gap-5' >
                <SkillCard logo={FbLogo} title="Firebase" count={4} />
                <SkillCard logo={AwsLogo} title="AWS" count={2} />
                <SkillCard logo={MaLogo} title="Microsoft Azure" count={1} />
            </div>
        </div>
    </section>
}

export default Skills
